export enum VisitVariantType {
  CLOSE_OUT = 'CLOSE_OUT',
  ANY_TIME = 'ANY_TIME',
  TIME_BOUND = 'TIME_BOUND',
  UNSCHEDULED = 'UNSCHEDULED',
  UNKNOWN = 'UNKNOWN',
}
